import React, { useEffect, useState } from "react";
import "./electrical";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import { useDispatch, useSelector } from "react-redux";
import InfoContainer from "./infoContainer";
import OneLineDiagram from "./oneLineDiagram";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
import { ProjectApi } from "../../../apis";

export default function ElectricalInfo({ emptyValues, oneLineRef }) {
  const ProjectRouter = ProjectApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [draftLoader, setDraftLoader] = useState(false);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);
  const user = conUser?.user;

  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  useEffect(() => {
    dispatch(updateQuantityInfo({ roofNo: 0 }));
    if (roofData.length === 1) {
      dispatch(
        updateQuantityInfo({
          allRoof: false,
          electricalConfiguration: "Single Roof",
        })
      );
    }
    // eslint-disable-next-line
  }, []);

  const handleNextPage = () => {
    const roofData = quantityInfo?.roofData || [];
    if (quantityInfo.electricalConfiguration === "Single Roof") {
      for (let i = 0; i < roofData.length; i++) {
        const element = roofData[i].inverterAnalysis;
        if (
          element.systemType === "Select" ||
          element.inverterManufacturer === "Select" ||
          element.inverterType === "Select"
        ) {
          alert(
            `Required electrical configuration for Roof ${
              i + 1
            } on Electrical page`
          );
          return false;
        }
      }
      navigate("/financial");
    } else {
      if (
        roofInfo.value.inverterAnalysis.systemType === "Select" ||
        roofInfo.value.inverterAnalysis.inverterManufacturer === "Select" ||
        roofInfo.value.inverterAnalysis.inverterType === "Select"
      ) {
        alert("Required electrical configuration on Electrical page");
        return false;
      } else {
        navigate("/financial");
      }
    }
  };

  return (
    <>
      <div className="electricalsInfoContainer">
        <div className="mainInfoBox">
          <InfoContainer emptyValues={emptyValues}></InfoContainer>
          <div className="mapContainer">
            <h1>Inverter Configuration Diagram</h1>
            <div className="analyticsGraph">
              <OneLineDiagram oneLineRef={oneLineRef}></OneLineDiagram>
            </div>
          </div>
        </div>
        <div className="containerButton">
          <div className="rightButton">
            <Link to="/design">
              <button className="backButton">
                <i className="bi bi-chevron-double-left"></i> Back
              </button>
            </Link>
          </div>
          <div className="rightButton">
            <button onClick={handleShow}>Save as Draft</button>

            <button className="nextButton" onClick={() => handleNextPage()}>
              Next <i className="bi bi-chevron-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
